import { FC } from "react";
import { fontSize, fontWeight, gutter } from "@app/styles/helpers/theme";
import styled, { ThemeProvider } from "styled-components";

import { theme } from "@app/styles/theme";

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
`;

const Div = styled.div`
    color: var(--dit-brand-color-neutral-100--map);
    font-family: ${props => props.theme.fontFamily}, sans-serif;
    padding: ${gutter(2)};
    width: 640px;

    h2 {
        font-size: ${fontSize(18)};
        font-weight: ${fontWeight("normal")};
        color: var(--dit-brand-color-neutral-100--map);
    }
`;

const Section = styled.div`
    margin-bottom: ${gutter(3)};
`;

interface Props {
    errorStatusCode: string;
}

// Services are not availables at this point. Translations are so not available.
export const AppNotLoaded: FC<Props> = ({ errorStatusCode }) => (
    <ThemeProvider theme={theme}>
        <Wrapper>
            <Div>
                <h1>Error: {errorStatusCode}</h1>
                <Section>
                    <h2>Apologies, we are experiencing some issues loading the site.</h2>
                    <p>The site is currently unavailable.</p>
                    <p>Please contact Technical Support.</p>
                </Section>
                <Section>
                    <h2>
                        Toutes nos excuses, mais nous éprouvons présentement quelques difficultés pour charger le site.
                    </h2>
                    <p>Le site est actuellement indisponible.</p>
                    <p>Veuillez communiquer avec le Centre d’assistance.</p>
                </Section>
            </Div>
        </Wrapper>
    </ThemeProvider>
);
